import React, { useEffect } from "react";
import { FcOk } from "react-icons/fc";
import { ReactComponent as LogoSVG } from "../../../assets/svg/akinrobotics-logo.svg";
import Translate from "../../../i18n/i18nTranslate";

export default function PreviewFinish({ onReturnSurvey }) {
  const [counter, setCounter] = React.useState(10);
  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);

    if (counter === 0) {
      onReturnSurvey();
    }
  }, [counter]);

  return (
    <div className="w-full flex flex-col justify-center items-center text-venter">
      <FcOk className="text-[90px] mt-12 " />
      <div className="text-2xl m-10 text-center">
        {Translate("Anketi tamamladığınız için teşekkür ederiz.", "Components.Preview.PreviewFinish.Thnks")}
      </div>

      <span
        className="countdown font-mono text-6xl">{counter}{Translate("sn", "Components.Preview.PreviewFinish.time")}
      </span>
      <button onClick={() => onReturnSurvey()} className="btn m-2 mb-8 mt-10">
        {Translate("Yeni Anket", "Components.Preview.PreviewFinish.New_Survy")}

      </button>
    </div>
  );
}
